// extracted by mini-css-extract-plugin
module.exports = {"head":"View_head__1RgBU","body":"View_body__orbtN","details":"View_details__jvffC","button":"View_button__3LlR7","preview":"View_preview__3Z_aR","iframe":"View_iframe__2wgNe"};